<template>
  <section
    class="component-ab289181"
    resmed-component-name="sleep_apnea_full_product_list"
  >
    <div class="component" v-if="items.length && init">
      <div class="container">
        <div class="categories">
          <p>Choose a product category below:</p>
          <ul>
            <li
              v-for="item in categories"
              v-bind:class="{ 'is-active': active === item }"
            >
              <a href="#" v-on:click.prevent="select(item)"
                >{{ item }} <span class="count">({{ qty[item] }})</span></a
              >
            </li>
          </ul>
        </div>

        <div class="stage">
          <div class="results">
            <h3 v-if="active === 'All'">
              {{ $getTranslation("All Products", $route.params.region) }}
            </h3>
            <h3 v-else>{{ active }}</h3>

            <p>
              {{ $getTranslation("Displaying", $route.params.region) }}: 1 -
              {{ qty[active] }} of <strong>{{ qty[active] }}</strong> {{ $getTranslation("results", $route.params.region) }}
            </p>
          </div>
          <div class="items">
            <div class="item" v-for="item in items">
              <div
                class="card"
                v-bind:class="item.category"
                v-bind:style="{ 'border-top-color': colors[item.category] }"
              >
                <div class="content">
                  <p class="category-name">{{ item.category }}</p>
                  <h3>{{ item.title }}</h3>
                  <ul>
                    <li v-for="item in item.description">{{ item.entry }}</li>
                  </ul>
                  <a
                    v-if="item.cta"
                    v-bind:target="item.cta.target"
                    v-on:click.capture="view(item)"
                    v-bind:href="item.cta.href"
                    class="btn cta-plain text-red icon right-arrow"
                    >{{ item.cta.text }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ab289181", // sleep_apnea_full_product_list
  props: ["acf"],
  data() {
    return {
      init: false,
      active: "",
      categories: [],
      colors: [],
      items: [],
      qty: {},
    };
  },
  watch: {
    active: {
      handler(val, prev) {
        let category = this.active.toLowerCase(),
          site = "sleep-apnea";

        axios
          .get(
            `//${location.hostname}/${site}/wp-json/resmed/v1/product-list/${category}`
          )
          .then((response) => {
            this.items = response.data.items;

            if (!this.init) {
              this.init = true;
              this.qty = response.data.qty;

              bus.$emit("recently-viewed:init", this.colors);
            }

            history.pushState("", "", `#${val.toLowerCase()}`);
          });
      },
      immediate: false,
    },
  },
  methods: {
    select(item) {
      this.active = item === this.active ? "All" : item;
    },
    view(arg) {
      if (!localStorage.getItem("recently-viewed")) {
        localStorage.setItem("recently-viewed", JSON.stringify([arg]));
      } else {
        let arr = JSON.parse(localStorage.getItem("recently-viewed"));

        let find = arr.find((el) => {
          return el.id === arg.id;
        });

        if (!find) {
          arr.unshift(arg);
        }

        localStorage.setItem("recently-viewed", JSON.stringify(arr));
      }
    },
  },
  created() {
    let hash = window.location.hash.substring(1);

    for (let value of this.acf.categories) {
      this.categories.push(value.name);
      this.colors[value.name.toLowerCase()] = value.color;
    }

    hash = hash.charAt(0).toUpperCase() + hash.slice(1); // ucfirst
    this.active = this.categories.includes(hash) ? hash : "All";
  },
};
</script>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

// extend style
%component {
  .categories {
    margin-bottom: 1.5rem;

    @media (min-width: 768px) {
      margin-bottom: 3rem;
    }

    p {
      @extend %body-small-bold;
      font-size: 0.875rem;
      text-align: center;
      margin-bottom: 1rem;

      @media (min-width: 768px) {
        text-align: left;
      }
    }

    ul {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      @media (min-width: 768px) {
        justify-content: flex-start;
      }

      li {
        margin: 0 1.25rem 1.25rem 0;

        @media (min-width: 768px) {
          margin: 0 1.25rem 0 0;
        }

        a {
          @extend %body-small-bold;
          color: $cc-resmed-dark-grey;
          display: inline-block;

          background-color: $cc-resmed-grey-15;
          border-radius: 21px;
          padding: 0.5rem 1.75rem;
          transition: all 0.5s;

          background-repeat: no-repeat;
          background-position: 0.5rem center;
        }

        &.is-active {
          a {
            background-color: $cc-resmed-action-red;
            background-image: url(#{$assets}/images/icon-active-button.svg);
            color: $cc-resmed-white;
            padding-right: 1rem;
            padding-left: 2.5rem;
          }
        }
      }
    }
  }

  .stage {
    padding: 1rem 0;

    .results {
      margin-bottom: 1rem;

      h3 {
        margin-bottom: 0.25rem;
      }
    }

    .items {
      .item {
        %border-color {
          border-top: 12px solid transparent;
        }

        .card {
          position: relative;
          width: 100%;

          @extend %border-color;
          background-color: $cc-resmed-white;
          border-radius: 6px;
          box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
          min-height: 302px;
          height: 100%;

          .category-name {
            position: relative;
            margin-bottom: 0.75rem;
            text-transform: capitalize;

            @extend %eyebrow;
            @extend %body-normal-bold;

            &:before {
              top: -0.625rem;
            }
          }
        }

        .content {
          padding: 2rem 1.75rem 4rem 1.75rem;

          h3 {
            margin-bottom: 1rem;
            min-height: 56px;
          }

          ul {
            list-style: none;
            margin-bottom: 0;

            li {
              text-indent: -1rem;
              padding-left: 1rem;

              &:before {
                content: "•";
                padding-right: calc(1rem / 2);
              }
            }
          }

          .btn {
            position: absolute;
            bottom: 2rem;
          }
        }
      }
    }
  }
}

// this component
.component-ab289181 {
  padding: 3rem 0;
  background-color: #f3f6f8;
  animation: fade-in 2s ease;

  @media (min-width: 992px) {
    min-height: 640px;
  }

  .component {
    @extend %component;

    .stage {
      .items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -0.25rem;

        @media (min-width: 768px) {
          margin: 0 -0.5rem;
        }
      }

      .item {
        width: 50%;
        padding: 0.25rem;

        @media (min-width: 768px) {
          padding: 0.5rem;
          width: 33.33333%;
        }

        @media (min-width: 1200px) {
          width: 25%;
        }
      }
    }
  }
}

// recently viewed component
.component-c70022cc {
  .component {
    @extend %component;

    h2 {
      position: relative;
      margin: 0;
      @extend %eyebrow-center;
    }
  }
}
</style>
